import { Tracking } from './Tracking';
// import { Popups } from '../Popups';

export enum SagaButtons {
    JOURNAL = 'journal',
    SHOP = 'shop',
    MAPGATE = 'mapgate',
    SOCIAL = 'social',
}

export default class SagaTracking {
    public static trackMenuClick(button: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `Saga_${button}_Click`,
        });
    }

    public static trackTabClick(tabId: string) {
        Tracking.addTrack({
            event: 'Design',
            dimension1: `SagaTab_${tabId}_Click`,
        });
    }
}
